import React, { Component } from "react";
import { Toast } from "antd-mobile";
import SearchHeader from "./searchHeader.js";
import "./search.css";
import $ from "../../ajax/ajax";
import { Link } from "react-router-dom";
import { getLog, getProductBymodel, getProductBySn } from "../../ajax/index.js";
import { createHashHistory } from "history";
const history = createHashHistory();
const nullvalue = require("../../assets/images/home/img_nullval.png");
const imgModel = require("../../assets/images/home/img_model.jpg");
const imgBarcode = require("../../assets/images/home/img_barcode.jpg");

const ERROR_MSG =
  "This serial code may be refer to history record ，could not find any result";
class SeachList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: "",
      listData: [" "], // 开始的时候不要让搜索不到的提示显示
      hasdata: true,
      loading: false,
      searchFlag: false, // 是否搜索过的状态
      resultsFlag: false, // 返回结果
    };
  }
  componentDidMount() {
    sessionStorage.setItem("barcodeHidden", "");
  }
  getKeyWord(data) {
    this.setState({
      keyword: data,
    });
  }
  searchKeyWord(data) {
    let _this = this;

    _this.setState({
      listData: data.data || [],
      searchFlag: true,
      loading: false,
    });
  }
  // 获取查询结果状态
  getResultsFlag = (flag) => {
    this.setState({
      resultsFlag: flag,
    });
  };

  getData = (keyword, searchType) => {
    if (searchType === "product") {
      Toast.loading("loading.....", 50000);
      let currentUrl = window.location.href;
      let appId = "tsp.errorcode";
      let pointName = `/seachlist?search`;
      getLog(currentUrl, appId, pointName);
      // 第一步先请求条形码编号接口 如果没有再请求故障编码
      // let productSerial = keyword.replace(/\s/g, '').substr(3, 8);

      // 第一步先查model
      getProductBymodel(keyword)
        .then((res) => {
          if (res.resultCode === "ISC-000" && res.data.length) {
            this.setState({
              searchFlag: true,
            });
            sessionStorage.setItem("barcodeHidden", "1");

            this.searchKeyWord(res);
            this.getResultsFlag(false);
            Toast.hide();
          } else {
            this.getResultsFlag(true);
            this.getSerialData(keyword);
          }
        })
        .catch(() => {
          this.getSerialData(keyword);
          Toast.hide();
        });
      // $.post({
      //   url:
      //     `/tsp/ibos/web//tspApi/product/customer/list?customerModel=` +
      //     keyword,
      //   // url: `/tsp/api/v1/anonymity/product/customer/model/` + keyword,
      //   showError: true,
      //   guid: "customerModel",
      // })
      //   .then((res) => {
      //     Toast.hide();

      //     if (res.status === 6000) {
      //       Toast.fail(ERROR_MSG);
      //       return;
      //     }

      //     if (res.resultCode === "ISC-000" && res.data.length) {
      //       this.setState({
      //         searchFlag: true,
      //       });
      //       sessionStorage.setItem("barcodeHidden", "1");

      //       this.searchKeyWord(res);
      //       this.getResultsFlag(false);
      //     } else {
      //       this.getResultsFlag(true);
      //       this.getSerialData(keyword);
      //     }
      //   })
      //   .catch(() => {
      //     this.getSerialData(keyword);
      //     Toast.hide();
      //   });
    } else {
      if (keyword) {
        // 读取本地缓存语言 默认上一次选中语言
        let language = localStorage.getItem("language");
        if (!language) {
          //获取浏览器语言
          language = navigator.language.slice(0, 2);
        }
        this.props.history.push({
          pathname: `/errorCodeTableByCode/${keyword},${language}`,
        });
      }
    }
  };

  getSerialData = (keyword) => {
    // 第二步查询条形码
    getProductBySn(keyword)
      .then((res) => {
        Toast.hide();
        if (res.resultCode === "ISC-000" && res.data.length) {
          if (res.data.length) {
            this.setState({
              searchFlag: true,
            });
          }
          sessionStorage.setItem("barcode", keyword);
          this.searchKeyWord(res);
          this.getResultsFlag(false);
        } else {
          Toast.fail(ERROR_MSG);
        }
        // if (res.status === 6000) {
        //   Toast.fail(ERROR_MSG);
        // }
      })
      .catch(() => {
        Toast.hide();
      });
    // $.get({
    //   url: `/tsp/api/v1/anonymity/product/serial/${keyword}`,
    //   showError: true,
    //   guid: "productSerial",
    // }).then((res) => {
    //   Toast.hide();
    //   if (res.status === 200 && res.data.length) {
    //     if (res.data.length) {
    //       this.setState({
    //         searchFlag: true,
    //       });
    //     }
    //     sessionStorage.setItem("barcode", keyword);
    //     this.searchKeyWord(res);
    //     this.getResultsFlag(false);
    //   }
    //   if (res.status === 6000) {
    //     Toast.fail(ERROR_MSG);
    //   }
    // });
  };

  goCategory() {
    history.push("/");
  }
  goToItem(item) {
    sessionStorage.setItem("customerModel", item.customerModel);
    this.props.history.push({
      pathname: `/productDetail/${item.productId}`,
    });
    // $.get({
    //   url: `/tsp/api/v1/anonymity/product/basic/` + item.productCode,
    //   showError: true,
    //   guid: "productBasic",
    // }).then((res) => {
    //   this.props.history.push({
    //     pathname: `/productDetail/${res.data.productId}`,
    //   });
    // });

    // this.props.history.push({
    //     pathname: `/productDetail/${item.productId}`
    // });
  }

  setLoading = () => {
    this.setState({
      loading: false,
    });
    // Toast.loading('正在加载...',0);
  };
  render() {
    let sampleClass = "sampleWrap ";
    if (this.state.searchFlag) {
      sampleClass = "sampleWrap displayNone";
    }

    let dom = (
      <div>
        <div className="noresult">
          <img src={nullvalue} alt="图片" />
          <h2>
            Sorry, we couldn't <br /> find any results.
          </h2>
          <p>Could not find any product </p>
        </div>
        <div className="code-btn-content noresult-btn">
          <button onClick={this.goCategory} className="code-btn">
            Product Category
          </button>
        </div>
      </div>
    );

    if (this.state.listData.length) {
      dom = (
        <div className="searchListWrap">
          <ul className="search-list">
            {this.state.listData.map((item, index) => {
              {
                /*初始化没有值的时候*/
              }
              if (!item.productCode) {
                return "";
              }
              return (
                <li
                  key={item.productId || index}
                  onClick={() => {
                    this.goToItem(item);
                  }}
                >
                  <p className="customerModel">{item.customerModel}</p>
                  <p className="categoryName">{item.brand}</p>
                  <p className="categoryName">{item.categoryEnName}</p>
                </li>
              );
            })}
          </ul>
          <div className={sampleClass}>
            <p className="sampleWrapText">Sample</p>
            <div className="sampleWrapLeft">
              <img src={imgModel} alt="" />
            </div>
            <div className="sampleWrapright">
              <img src={imgBarcode} alt="" />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="transition-item list-page">
        <div className="seachListWrap">
          <SearchHeader
            getKeyWord={(data) => this.getKeyWord(data)}
            setLoading={this.setLoading}
            getData={this.getData}
          ></SearchHeader>
          {!this.state.resultsFlag ? (
            dom
          ) : (
            <div
              style={{
                paddingBottom: "44px",
                background: "#fff",
                height: "690px",
              }}
            >
              <div>
                <img width="100%" src={nullvalue} alt="图片" />
                <h2
                  style={{
                    fontSize: "18px",
                    color: "#656667",
                    textAlign: "center",
                    lineHeight: "24px",
                    fontWeight: 100,
                  }}
                >
                  Maintaining!
                  <br />
                  Service Paused{" "}
                </h2>
              </div>
              <div style={{ marginTop: "100px", textAlign: "center" }}>
                <button
                  style={{
                    background: "#4C84FF",
                    borderRadius: "4px",
                    border: 0,
                    height: "36px",
                    width: "85%",
                    color: "#fff",
                    fontFamily: "SFUIText-Medium",
                    fontSize: "16px",
                    color: "#FFFFFF",
                    letterSpacing: "-0.69px",
                  }}
                  onClick={this.goCategory}
                  className="code-btn"
                >
                  Back to Home{" "}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default SeachList;



// WEBPACK FOOTER //
// ./src/pages/search/seachList.js